// extracted by mini-css-extract-plugin
export default {"container":"VerifyPage_container__J3WCK"};